import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/auth/oauth-callback')({
  component: OAuthCallback,
});

function OAuthCallback() {
  const { setAuth } = useAuthStore();
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('access_token') || '';
    const err = params.get('error') || '';

    if (window.opener) {
      window.opener.postMessage(
        { type: 'oauth_callback', access_token: accessToken, error: err },
        window.location.origin,
      );
      window.close();
      return;
    }

    if (err) {
      setError(err);
      setDone(true);
      return;
    }
    if (accessToken) {
      setAuth(accessToken);
      window.location.replace('/dashboard');
      return;
    }
    setError('Unexpected response. Please try again.');
    setDone(true);
  }, [setAuth]);

  if (!done) {
    return <div className="flex h-screen items-center justify-center text-muted-foreground">Completing login…</div>;
  }

  if (error === 'not_invited') {
    return (
      <div className="mx-auto mt-24 max-w-md rounded-xl border border-border bg-background p-8 text-center">
        <h1 className="font-heading text-2xl font-semibold">This account isn&apos;t authorised</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          KodPrep is invite-only. Ask your trainer or organisation admin to send you an invite, or get in touch with us.
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <a href="https://kodprep.com/contact" className="rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground">Talk to KodPrep</a>
          <Link to="/login" className="text-sm text-muted-foreground hover:underline">Back to sign-in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto mt-24 max-w-md rounded-xl border border-border bg-background p-8 text-center">
      <h1 className="font-heading text-2xl font-semibold">Sign-in failed</h1>
      <p className="mt-2 text-sm text-muted-foreground">{error}</p>
      <Link to="/login" className="mt-6 inline-block text-sm text-primary hover:underline">Back to sign-in</Link>
    </div>
  );
}
